<template>
    <div class="body-category-info">
        <img src="../../../assets/images/List/img-category-info.png" alt="">
        <div class="border-category-info">
            <div class="text-title">{{ moduleTitle }}</div>
            <label>
                <input class="category-title" v-model="title" maxlength="10" placeholder="请输入分类名称(最多10个字符)" type="text">
            </label>
            <div class="button-items">
                <div class="button-close my-cursor" @click.stop="close">取消</div>
                <div class="button-submit my-cursor" @click.stop="submit">保存</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
name: "CategoryInfo",
    data(){
        return {
            moduleTitle: "",
            title: "",
        }
    },
    props: {
        categoryItem: {
            type: Object,
            default: {},
        }
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            if(this.title ===""){
                this.$PopupToast("分类名字不能为空");
                return
            }
            this.$emit("submitEvent", this.title);
            this.close();
        }
    },
    mounted(){
        if(this.categoryItem.categoryId){
            // 修改
            this.moduleTitle = "修改分类";
            this.title = this.categoryItem.title;
        }else{
            this.moduleTitle = "新建分类";
        }
    }
}
</script>

<style scoped>
div.body-category-info{
    width: 4.72rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 30vh auto;
}
div.body-category-info img{
    width: 1.55rem;
    height: 1.03rem;
    display: block;
    margin: -1.11rem auto 0.08rem;
}
div.border-category-info{
    width: 100%;
    height: auto;
    padding: 0.2rem 0.16rem 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}

div.text-title{
    font-weight: bold;
    font-size: 0.22rem;
    color: #000000;
    line-height: 0.26rem;
    text-align: center;

}

input.category-title{
    width: 100%;
    height: 0.52rem;
    border: 0.02rem solid #000000;
    border-radius: 0.1rem;
    margin: 0.3rem auto auto;
    box-sizing: border-box;
    display: block;
    text-indent: 0.17rem;

    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    line-height: 0.48rem;
    text-align: left;
}
div.button-items{
    width: 100%;
    height: 0.48rem;
    margin-top: 0.4rem;
    display: flex;
    box-sizing: border-box;
    padding: 0 0.34rem;
    justify-content: space-between;
}
div.button-submit, div.button-close{
    width: 1.4rem;
    height: 0.48rem;
    border-radius: 0.38rem;
    border: 0.02rem solid #000000;
    font-size: 0.16rem;
    line-height: 0.43rem;
    text-align: center;
}

div.button-close{
    background: #FFFFFF;
    box-shadow: inset 0 -0.05rem 0 0 #9F9F9F;
    color: #000000;
}
div.button-submit{
    background: #FC8470;
    box-shadow: inset 0 -0.05rem 0 0 #FFF4C9;
    color: #FFFFFF;
}
</style>